import useAuth from '@/hooks/useAuth';
import * as config from "../config";
import axios, { AxiosResponse } from 'axios';

export interface University {
  id: string;
  name: string;
  city: string;
  state: string;
  zipcode: string;
  admissionRate: number;
  homePage?: string;
}

export const useUniversitiesSearch = () => {
  const { user } = useAuth();
  const token = user?.token;

  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const search = async (name: string): Promise<University[]> => {
    if (!token) return [];

    const url = `${config.apiConfig.host}/universities?name=${encodeURIComponent(name)}`;
    const response = await axios.get(url, { headers });
    return response.data;
  };

  return { search };
};
